module.exports = __webpack_public_path__ + "img/pro.274c0dc9.jpg";